/**
 * Stores Shopify currency rates in local storage for use in a web pixel.
 */
document.addEventListener('DOMContentLoaded', () => {
  try {
    const activeCurrency = window?.Shopify?.currency?.active;
    const currencyRate = window?.Shopify?.currency?.rate;
    if (!activeCurrency || !currencyRate) return;

    const storedCurrency = localStorage.getItem('SwyftCurrency');
    let currency = {};

    try {
      currency = storedCurrency ? JSON.parse(storedCurrency) : {};
      if (typeof currency !== 'object' || Array.isArray(currency)) currency = {};
    } catch {
      currency = {};
    }

    currency[activeCurrency] = currencyRate;
    localStorage.setItem('SwyftCurrency', JSON.stringify(currency));
  } catch {}
});